module.exports = __webpack_public_path__ + "a768e7de/img/ion_calendar-number.3ac5bd07.svg";